export default "__VITE_ASSET__ec26e700__"